import { ChangeDetectorRef, Component, EventEmitter, OnInit, Pipe, PipeTransform, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { HttpService } from 'src/app/service/http/http.service';
import { LoaderService } from 'src/app/service/loader/loader.service';
import { SharedService } from 'src/app/service/shared/shared.service';
import { Config } from 'src/app/app-constant';
import { ToastController } from '@ionic/angular';
import { DatePipe } from '@angular/common';
import { ConfirmationPopupComponent } from 'src/app/shared/popups/confirmation-popup/confirmation-popup.component';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { PdfDownloadService } from 'src/app/pdf-download-service.service';
import { DataRefreshService } from 'src/app/services/dataRefreshService.service';
import { calculateFiscalYear, formatYearRanges } from 'src/app/shared/commen-function-file';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AddprojectmodalpopupComponent } from '../addprojectmodalpopup/addprojectmodalpopup.component';
import { ReportConfigComponent } from '../report-config/report-config.component';
import { MobileResponsiveService } from 'src/app/services/mobile-view/mobile-responsive.service';
import { GenericService } from 'src/app/services/genericService/generic.service';
import { DwmGenericServiceService, TableState } from '../../_DWM-Generic-Services/generic-service.service';
import { DwmrndadminaudittrailComponent } from './dwmrndadminaudittrail/dwmrndadminaudittrail.component';

@Component({
  selector: 'app-sub-admin',
  templateUrl: './sub-admin.component.html',
  styleUrls: ['./sub-admin.component.scss']
})
export class SubAdminComponent implements OnInit {
  buttonColorName: any;
  loggedInUserCompanyID: any;
  loggedInUserName: any;
  selectedYearForDWM: any = null;
  loggedInCompanyFiscalyear: any;
  subModuleButtonColor: any | null;
  loggedInUserEmpCode: any | null;
  loggedInUserId: any | null;
  loggedInCompanyMDCode: any | null;
  loggedInUserRole: any;
  loggedInUserRoles: any;
  loggedInCompanyReviewCycle: any | null;
  loggedInUserRoleIsEmployee: any;
  fromYear: any;
  selectedYear: any;
  toYear: any;
  isCurrentYearSelected: boolean = false;
  pmsYears: any = [];
  allowedToEditDelete: boolean = false;
  selectAllCheckbox: boolean = false;
  selectedSizeForProduct: any = 25;
  getProductsList: any[] = [];
  searchString: any = null;
  currentPage: number = 0;
  totalPages: number = 0;
  totalItems: number = 0;
  pageSize: number = 25;
  page: any = 0;
  isAnySelected: boolean = false;
  dropdownSettings: IDropdownSettings = {};
  displayedColumns: string[] = ['productNo', 'productName', 'businessUntil', 'customerName', 'actions'];

  constructor(
    private datePipe: DatePipe,
    public sharedService: SharedService,
    private snackBar: MatSnackBar,
    private loadingService: LoaderService,
    public dialogRef: MatDialogRef<AddprojectmodalpopupComponent>,
    private loader: LoaderService,
    private encryptionService: EncryptionService,
    private httpService: HttpService,
    private config: Config,
    public router: Router,
    private fb: FormBuilder,
    public dialog: MatDialog,
    public dwmGenericServiceService: DwmGenericServiceService,
    private activatedroute: ActivatedRoute,
    private toastr: ToastrService,
    private toastController: ToastController,
    public genericService: GenericService,
    private cdRef: ChangeDetectorRef,
    public mobileResponsiveService: MobileResponsiveService,
    private PdfDownload: PdfDownloadService,
    private dataRefreshService: DataRefreshService
  ) {}

  ngOnInit() {
    this.buttonColorName = sessionStorage.getItem('buttonColorName');
    this.subModuleButtonColor = sessionStorage.getItem('subModuleButtonColor');
    this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));

    this.loggedInCompanyFiscalyear = sessionStorage.getItem('loggedInCompanyFiscalyear');
    this.loggedInUserEmpCode = sessionStorage.getItem('empCode');
    if (this.loggedInCompanyFiscalyear) {
      this.loggedInCompanyFiscalyear = this.encryptionService.decryptData(this.loggedInCompanyFiscalyear);
    }
    this.loggedInUserId = sessionStorage.getItem('loggedInUserId');
    this.loggedInUserName = sessionStorage.getItem('loggedInUserName');
    this.loggedInUserId = sessionStorage.getItem('loggedInUserRole');
    this.loggedInCompanyMDCode = sessionStorage.getItem('loggedInCompanyMDCode');
    if (this.loggedInUserRole) {
      this.loggedInUserRole = this.encryptionService.decryptData(this.loggedInUserRole);
    }
    this.loggedInUserRoles = JSON.parse(sessionStorage.getItem('loggedInUserRoles') || '[]');
    this.loggedInCompanyReviewCycle = sessionStorage.getItem('loggedInCompanyReviewCycle') || null;
    if (this.loggedInUserRoles.length == 1) {
      for (let i = 0; i < this.loggedInUserRoles?.length; i++) {
        if (this.loggedInUserRoles[i].displayName == 'Employee') {
          this.loggedInUserRoleIsEmployee = true;
        }
      }
    }

    this.dropdownSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'name',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 1,
      allowSearchFilter: true
    };
    this.getpmsyearlist();
  }

  headerNameForRNDTable: string[] = ['Product No', 'Product Name ', 'Plant Location', 'Business Unit', 'Customer Name', 'Action'];

  getpmsyearlist() {
    this.httpService.callGetService(this.config.getpmsyearlist + this.loggedInUserCompanyID).subscribe((data: any) => {
      this.pmsYears = formatYearRanges(data?.data?.yearRanges);
      // console.log("fiscal year..", this.loggedInCompanyFiscalyear);

      const { fiscalStartYear, fiscalEndYear } = calculateFiscalYear(this.loggedInCompanyFiscalyear);

      const yearValue = `${fiscalStartYear}-${fiscalEndYear}`;

      this.setSelectedYear(yearValue);
    });
  }

  setSelectedYear(yearValue: string): void {
    const selectedYearObj = this.pmsYears.find((ele: any) => ele.year === yearValue);
    if (selectedYearObj) {
      this.selectedYearForDWM = selectedYearObj?.year;

      let test = selectedYearObj?.year.split('-');
      this.fromYear = test[0];
      this.toYear = test[1];
      this.defaultCallFunctionsList();
      [this.fromYear, this.toYear] = selectedYearObj.year.split('-');
    }
  }

  defaultCallFunctionsList() {
    this.getProductsData();
  }

  selectYearSetup(year: any) {
    this.selectedYearForDWM = year;
    this.selectedYear = year;
    this.defaultCallFunctionsList();
  }

  getYearSetupForDWM(year: any) {
    this.selectedYearForDWM = year;
    this.selectedYear = year;
    const { fiscalStartYear, fiscalEndYear } = calculateFiscalYear(this.loggedInCompanyFiscalyear);
    const currentFiscalYear = `${fiscalStartYear}-${fiscalEndYear}`;
    this.isCurrentYearSelected = year === currentFiscalYear;
  }

  // ================ Report Config Dialog ===========================

  openReportConfig() {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.maxWidth = '300px';
    dialogConfig.panelClass = ['phi_mdc_dialog__container_100_phi_mdc_dialog__content_85_vh'];
    dialogConfig.data = {};
    // dialogConfig.panelClass = 'custom-dialog-container';
    const dialogRef = this.dialog.open(ReportConfigComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {});
  }

  // ================== Add Project Modal Popup ========================

  addProductDialog() {
    const dialogRef = this.dialog.open(AddprojectmodalpopupComponent, {
      // width: '70%',
      maxWidth: '767px',
      panelClass: ['phi_mdc_dialog__container_100_phi_mdc_dialog__content_85_vh'],
      disableClose: true,
      data: {
        isEdit: false
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.getProductsData();
      }
    });
  }

  // ================ Edit Project Modal Popup ========================

  editProject(product: any) {
    const dialogRef = this.dialog.open(AddprojectmodalpopupComponent, {
      maxWidth: '767px',
      panelClass: ['phi_mdc_dialog__container_100_phi_mdc_dialog__content_85_vh'],
      disableClose: true,
      data: {
        isEdit: true,
        product: product
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.getProductsData();
      }
    });
  }

  deleteProject(project: any) {}

  toggleProjectStatus(project: any) {
    project.open = !project.open;
  }

  // -------------------------- R & D Product ----------------------

  onSearch(value: string) {
    this.searchString = value?.trim().toLowerCase();

    if (!this.searchString) {
      this.filteredProductsList = [...this.fullProductsList];
    } else {
      this.filteredProductsList = this.fullProductsList.filter(p => p.productNumber?.toLowerCase().includes(this.searchString) || p.productName?.toLowerCase().includes(this.searchString) || p.businessUnit?.toLowerCase().includes(this.searchString) || p.productCustomer?.toLowerCase().includes(this.searchString));
    }

    this.currentPage = 0; // Reset to first page
    this.updatePagination();
  }

  onSelectSizeOfProduct() {
    this.pageSize = this.selectedSizeForProduct;
    this.currentPage = 0;
    this.updatePagination();
  }

  // --------------- Get R & D Product List ----------------------

  fullProductsList: any[] = []; // Raw API list (never modified)
  filteredProductsList: any[] = []; // After search filter

  getProductsData() {
    this.httpService.callGetService(`${this.config.getProducts}?companyId=${this.loggedInUserCompanyID}`).subscribe((res: any) => {
      // this.fullProductsList = res.data.map((item: any) => ({
      //   ...item,
      //   id: item.productId
      // }));

      this.fullProductsList = (res.data || [])
        .filter((item: any) => item.isActive === true)
        .map((item: any) => ({
          ...item,
          id: item.productId
        }));
      // On load – filtered list = full list
      this.filteredProductsList = [...this.fullProductsList];
      console.log('Active USers...', this.filteredProductsList);
      this.updatePagination();
    });
  }

  updatePagination() {
    this.totalItems = this.filteredProductsList.length;
    this.totalPages = Math.ceil(this.totalItems / this.pageSize);

    if (this.currentPage >= this.totalPages && this.totalPages > 0) {
      this.currentPage = this.totalPages - 1;
    }

    const start = this.currentPage * this.pageSize;
    const end = start + this.pageSize;

    this.getProductsList = this.filteredProductsList.slice(start, end);
  }

  // --------------- Select / De-select Records ----------------------

  selectSingleRecord(event: any, product: any, index: number) {
    product.checkboxCheck = event.checked;

    const allEnabledSelected = this.getProductsList.filter((p: any) => !p.allowedToEditDelete).every((p: any) => p.checkboxCheck === true);

    this.selectAllCheckbox = allEnabledSelected;
    this.isAnySelected = this.getProductsList.some(p => p.checkboxCheck);
  }

  selectALLRecords(event: any) {
    const isChecked = event.checked;

    this.selectAllCheckbox = isChecked;

    this.getProductsList.forEach((product: any) => {
      product.checkboxCheck = isChecked;
      this.isAnySelected = this.getProductsList.some(p => p.checkboxCheck);
    });
  }

  downloadReport(downloadType: string) {
    const source = this.filteredProductsList || [];

    if (!source.length) {
      this.toastr.warning('No product data to export!');
      return;
    }

    /* ===================== EXCEL ===================== */
    if (downloadType === 'excel') {
      const excelData = source.map((product: any) => {
        return {
          'Product No': product?.productNo || '',
          'Product Name': product?.productName || '',
          'Plant Location': product?.plantLocation || '',
          'Business Unit': product?.businessUnit || '',
          'Customer Name': product?.productCustomer || ''
        };
      });

      this.dwmGenericServiceService.saveAsExcelFile(excelData, 'R&D Product List', 'rnd_product_list');
    }

    /* ====================== PDF ====================== */
    if (downloadType === 'pdf') {
      // PDF headers (excluding Action column)
      const pdfTableHeaders: string[] = ['Product No', 'Product Name', 'Plant Location', 'Business Unit', 'Customer Name'];

      // PDF rows
      const pdfTableData = source.map((product: any) => {
        return [product?.productNo || '', product?.productName || '', product?.plantLocation || '', product?.businessUnit || '', product?.productCustomer || ''];
      });

      this.dwmGenericServiceService.downloadTableAsPdf(pdfTableHeaders, pdfTableData, 'R&D Product List', 'rnd_product_list');
    }
  }

  applyFilters() {}

  // --------------------- Delete Product on Checkboxes----------------------------

  deleteProduct() {
    const selectedProducts = this.getProductsList.filter((p: any) => p.checkboxCheck === true && p.id).map((p: any) => p.id);

    if (selectedProducts.length === 0) {
      this.toastr.warning('Please select at least one product');
      return;
    }

    const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
      disableClose: true,
      maxWidth: '450px',
      panelClass: ['phi_mdc_dialog__container_100_phi_mdc_dialog__content_85_vh'],
      data: {
        msg: 'Are you sure you want to delete?',
        btn1: 'Cancel',
        btn2: 'Delete',
        btn2BgColor: this.buttonColorName
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        const payload = {
          companyId: this.loggedInUserCompanyID,
          ids: selectedProducts
        };

        this.httpService.callPostService(this.config.deleteProduct, payload).subscribe({
          next: (res: any) => {
            this.toastr.success('Deleted successfully', 'Success');
            this.getProductsData();
            this.selectAllCheckbox = false;
          },
          error: () => {
            this.toastr.error('Delete failed');
          }
        });
      }
    });
  }

  // --------------------- Pagination ---------------------------------

  get startItem(): number {
    return this.totalItems === 0 ? 0 : this.currentPage * this.pageSize + 1;
  }

  get endItem(): number {
    return Math.min((this.currentPage + 1) * this.pageSize, this.totalItems);
  }

  changePage(pageNumber: number) {
    if (pageNumber < 0 || pageNumber >= this.totalPages) return;
    this.currentPage = pageNumber;
    this.updatePagination();
  }

  // ====================== Ascending / Descending Sort ========================
  onSortAssending(column: string) {
    this.filteredProductsList.sort((a, b) => {
      if (a[column] < b[column]) return -1;
      if (a[column] > b[column]) return 1;
      return 0;
    });
  }
  onSortDesending(column: string) {
    this.filteredProductsList.sort((a, b) => {
      if (a[column] > b[column]) return -1;
      if (a[column] < b[column]) return 1;
      return 0;
    });
  }

  // Audit trail

  onClickAuditTrail() {
    const dialogRef = this.dialog.open(DwmrndadminaudittrailComponent, {
      panelClass: ['phi_mdc_dialog__container_100_phi_mdc_dialog__content_85_vh'],
      disableClose: true,
      data: {}
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
      }
    });
  }
}
